"use client";

import React, { useEffect, useState } from "react";
import { getTransactions } from "../../../services/server-actions";
import { ReactComponent as ArrowUp } from "../../../assets/icons/RedUpArrow.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/GreendownArrow.svg";
import { ReactComponent as NotFoundIcon } from "../../../assets/icons/NotFound.svg";
import HeaderTitle from "../Header/HeaderTitle";
import styles from "./Transactions.module.css";
import { MobileCustomerProfileTransactionDto } from "../../../services/shared/service-proxies/service-proxies";
import { DateTime } from "ts-luxon";
import { useTheme } from "../../../ThemeContext";

const TransactionsList: React.FC<{
  transactions: MobileCustomerProfileTransactionDto[];
}> = ({ transactions }) => {
  const { theme } = useTheme();

  return (
    <div className={styles.transactionsList}>
      {transactions.map((transaction, index) => {
        const formattedTime = transaction.onDate
          ? DateTime.fromISO(transaction.onDate.toString()).toFormat("HH:mm")
          : "نامشخص";

        const isIncome = transaction.type === 1;

        return (
          <div
            key={`${transaction.partnerId}-${index}`}
            className={styles.transactionItem}
          >
            <div className={styles.transactionInfo}>
              امروز
              <span className={styles.date}>{formattedTime}</span>
            </div>

            <div className={styles.transactionAmount}>
              <div className={styles.amountDescriptionContainer}>
                <span className={isIncome ? styles.increase : styles.decrease}>
                  {transaction.amount !== 0
                    ? `${transaction.amount.toLocaleString()} تومان`
                    : "بدون تغییر"}
                </span>
                <p className={styles.description}>
                  {transaction.description ?? "بدون توضیح"}
                </p>
              </div>

              <div
                className={styles.icon}
                style={{
                  color: isIncome ? theme.success : theme.danger,
                }}
              >
                {isIncome ? <ArrowUp /> : <ArrowDown />}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const Transactions: React.FC = () => {
  const [transactions, setTransactions] = useState<
    MobileCustomerProfileTransactionDto[]
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true); // ✅ اضافه شد

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      setError(null);
      try {
        const cachedTransactions = localStorage.getItem("transactions");
        if (cachedTransactions) {
          const parsed = JSON.parse(cachedTransactions).map((tx: any) => ({
            ...tx,
            onDate: tx.onDate ? DateTime.fromISO(tx.onDate) : undefined,
          }));
          setTransactions(parsed);
        } else {
          const data = await getTransactions();
          setTransactions(data);
          localStorage.setItem("transactions", JSON.stringify(data));
        }
      } catch (error) {
        console.error("❌ خطا در دریافت تراکنش‌ها:", error);
        // فقط اگر تراکنشی بود خطا بده
        if (transactions.length > 0) {
          setError(
            "مشکلی در دریافت اطلاعات رخ داده است. لطفاً دوباره تلاش کنید."
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <>
      <HeaderTitle title="تاریخچه تراکنش‌ها" onBackNavigateTo="/profile" />
      <div className={styles.transactionsContainer}>
        {!loading && transactions.length > 0 ? (
          <TransactionsList transactions={transactions} />
        ) : !loading && transactions.length === 0 ? (
          <div className={styles.noDataMessage}>
            <NotFoundIcon className={styles.notFoundIcon} />
            <p> .تا این لحظه تراکنشی در حساب کاربری شما ثبت نشده است </p>
          </div>
        ) : null}

        {error && <p className={styles.error}>{error}</p>}
      </div>
    </>
  );
};

export default Transactions;
